import { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../../shared/components/ModalBasic";
import { AlertIcon } from "../../../../../shared/icons/AlertIcon";
import { TModalsIds } from "../../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  handleOk: (prop?: unknown) => void;
  closeModal: (id: TModalsIds) => void;
}

export const WarningModal = ({ handleOk, closeModal, ...rest }: Props) => {
  const warningModal = useModalSelectors("warning_modal");
  const { t } = useTranslation();
  return (
    <ModalBasic
      open={warningModal.isOpen}
      onOk={() => {
        handleOk(warningModal.info);
        closeModal("warning_modal");
      }}
      hasHeader={false}
      onCancel={() => closeModal("warning_modal")}
      onClose={() => closeModal("warning_modal")}
      buttonOkText={"Продолжить"}
      hasFooter
      {...rest}
    >
      <div className={styles["warning-container"]}>
        <AlertIcon className={styles["warning-icon"]} />
        <p className={styles.warning}>
          Запуск приведёт к потере уже распознанных данных. Продолжить?
        </p>
      </div>
    </ModalBasic>
  );
};
